import { FC } from 'react'
import ModulePartnerPageComponent from '../ModulePartnerPage'
import { AwardsModulePartner } from '../../../types/components'

const ModulePartnerPage: FC<{
  moduleProps: AwardsModulePartner['attributes']
}> = ({ moduleProps }) => {
  return (
    <ModulePartnerPageComponent
      moduleProps={moduleProps}
    />
  )
}

export default ModulePartnerPage
